import { EMPTY_ALERT_STATE } from 'modules/campaigns/alerts/constants';
import { AlertMetricsByMedium, SavedAlertsByMedium } from 'modules/campaigns/alerts/types';
import { createContext, useContext } from 'react';
import { DefaultValues } from 'react-hook-form';
import noop from 'utils/noop';

export interface ProjectAlertsContextState {
  allAlertMetrics: AlertMetricsByMedium;
  defaultValues: DefaultValues<Record<string, unknown>> | undefined;
  isLoadingMetrics: boolean;
  isLoadingProjectCampaignAlerts: boolean;
  savedAlerts: SavedAlertsByMedium;
  setSavedAlerts: (alerts: SavedAlertsByMedium) => void;
}

export const DEFAULT_PROJECT_ALERTS_CONTEXT_STATE: ProjectAlertsContextState = {
  defaultValues: {},
  allAlertMetrics: EMPTY_ALERT_STATE,
  isLoadingMetrics: false,
  isLoadingProjectCampaignAlerts: false,
  savedAlerts: EMPTY_ALERT_STATE,
  setSavedAlerts: noop,
};

export const ProjectAlertsContext = createContext<ProjectAlertsContextState>(
  DEFAULT_PROJECT_ALERTS_CONTEXT_STATE,
);
export const useProjectAlertsContext = () => useContext(ProjectAlertsContext);
